import React from 'react';
import { motion } from 'framer-motion';
import SectionHeader from '../SectionHeader/SectionHeader';


const trustCards = [
  {
    title: '28+ Years Experience',
    description: 'Founded in April 1996, we bring decades of experience in software development and digital solutions.',
    accent: 'gold',
    image: '/assest/features/28years.png',
    imageAlt: '28 years experience illustration',
  },
  {
    title: 'Partners, Not Vendors',
    description: 'We work closely with you as true partners, understanding your vision and delivering lasting value.',
    accent: 'teal',
    image: '/assest/features/partners.png',
    imageAlt: 'Partners not vendors illustration',
  },
  {
    title: 'Quality & Simplicity',
    description: 'We prioritize both excellence in code and user-friendly interfaces that are easy to use and maintain.',
    accent: 'green',
    image: '/assest/features/quality.png',
    imageAlt: 'Quality and simplicity illustration',
  },
  {
    title: 'Full Support',
    description: 'Comprehensive ongoing support and maintenance services to keep your systems running smoothly.',
    accent: 'gold',
    image: '/assest/features/fullsupport.png',
    imageAlt: 'Full support illustration',
  },
];

export default function TrustSection() {
  return (
    <section className="py-24 px-4 sm:px-6 lg:px-8 bg-[#0e3a63]">
      <div className="max-w-7xl mx-auto">
        <SectionHeader 
          badge="About Us"
          title="Why Choose MakSoft"
          subtitle="28+ years of excellence in software development, delivering lasting value and state-of-the-art solutions."
          accentColor="teal"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {trustCards.map((card, index) => {
            const accentColor = card.accent === 'gold' ? '#EFCD86' : card.accent === 'teal' ? '#046A8C' : '#66B152';
            
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: false }}
                transition={{ duration: 0.5, delay: index * 0.15 }}
                className="group relative rounded-2xl bg-[#0d1f33] border border-white/10 hover:border-[#EFCD86]/50 transition-all duration-300 hover:scale-[1.02] overflow-hidden"
                style={{
                  background: 'rgba(13, 31, 51, 0.9)',
                  backdropFilter: 'blur(8px)',
                }}
              >
                {/* Top - Image with yellow border */}
                <div className="h-48 w-full p-4 relative">
                  <div className="absolute inset-0 opacity-20" style={{
                    background: `radial-gradient(circle at center, ${accentColor}20, transparent 70%)`
                  }} />
                  <div className="relative z-10 w-full h-full rounded-xl overflow-hidden border-4 border-white shadow-lg shadow-[#EFCD86]/20">
                    <img
                      src={card.image}
                      alt={card.imageAlt}
                      className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                      loading="lazy"
                    />
                  </div>
                </div>

                {/* Bottom - Content */}
                <div className="p-6 text-center">
                  <h3 className="text-xl font-bold text-white mb-3">{card.title}</h3>
                  <p className="text-white/90 leading-relaxed text-sm">{card.description}</p>
                </div>

                {/* Hover glow effect */}
                <div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
                  style={{
                    background: `radial-gradient(circle at 50% 50%, ${accentColor}10, transparent 70%)`
                  }}
                />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
